import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem('cookie_consent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 md:p-6">
      <div className="max-w-4xl mx-auto bg-neutral-900 border border-white/10 rounded-2xl shadow-2xl p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Icon and Text */}
          <div className="flex items-start gap-4 flex-1">
            <div className="w-10 h-10 rounded-full bg-[#00F0FF]/10 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-[#00F0FF]" />
            </div>
            <div>
              <h3 className="font-semibold text-white mb-1">We use cookies</h3>
              <p className="text-sm text-neutral-400">
                We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                By clicking &ldquo;Accept&rdquo;, you consent to our use of cookies.{' '}
                <Link to="/privacy#cookies" className="text-[#00F0FF] hover:underline">
                  Learn more
                </Link>
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 w-full md:w-auto">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="flex-1 md:flex-none border-white/20 hover:bg-white/5"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="flex-1 md:flex-none bg-[#00F0FF] hover:bg-[#00C2CC] text-black font-semibold"
            >
              Accept
            </Button>
          </div>

          {/* Close button */}
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 md:hidden text-neutral-400 hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
